import clsx from "clsx";
import { ToggleGroup } from "radix-ui";

export interface SegmentedToggleItem {
  label: string;
  value: string;
  disabled?: boolean;
}

interface SegmentedToggleProps {
  items: SegmentedToggleItem[];
  value: string;
  onValueChange: (value: string) => void;
  ariaLabel: string;
  className?: string;
}

const itemClassName = clsx(
  "flex h-6 items-center justify-center rounded px-2.5 text-label-100 transition",
  "text-tertiary enabled:hover:text-secondary",
  "data-[state=on]:bg-card data-[state=on]:text-secondary data-[state=on]:shadow-sm",
  "outline-hidden focus-visible:shadow-focus",
  "disabled:cursor-not-allowed disabled:opacity-50",
);

const SegmentedToggle = ({
  items,
  value,
  onValueChange,
  ariaLabel,
  className,
}: SegmentedToggleProps) => {
  return (
    <ToggleGroup.Root
      type="single"
      rovingFocus={false}
      aria-label={ariaLabel}
      value={value}
      onValueChange={(newValue) => {
        if (newValue) {
          onValueChange(newValue);
        }
      }}
      className={clsx(
        "flex h-8 items-center gap-1 rounded-lg border border-primary bg-subtle p-1",
        className,
      )}
    >
      {items.map((item) => (
        <ToggleGroup.Item
          key={item.value}
          value={item.value}
          disabled={item.disabled}
          className={itemClassName}
        >
          {item.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
};

export default SegmentedToggle;
